import { useCallback } from 'react';
import { useSnapshot } from 'valtio';

import { store } from './useCategoriesOpen.store';

type UseCategoriesOpenReturn = {
  openCategoryIds: string[];

  // (string|number) Just to make the types in @minoru/react-dnd-treeview easier
  setOpenCategoryIds: (openCategoryIds: (string | number)[]) => void;
};

export function useCategoriesOpen(
  collectionId: string,
): UseCategoriesOpenReturn {
  const { [collectionId]: openCategoryIds } = useSnapshot(store);

  const setOpenCategoryIds = useCallback(
    (newOpenCategoryIds: (string | number)[]) => {
      store[collectionId] = newOpenCategoryIds as string[];
    },
    [collectionId],
  );

  return {
    setOpenCategoryIds,
    openCategoryIds: openCategoryIds as string[],
  };
}
